import React, { SVGProps } from 'react';

export const IconEye = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" fillRule="evenodd" d="M29.02 16c0-.45-3.82-8-13.03-8-9.21 0-13.01 7.64-13.01 8 0 .37 3.67 8 13 8 9.34 0 13.04-7.55 13.04-8ZM16 20a4 4 0 1 0-.01-8 4 4 0 0 0 .01 8Z" clipRule="evenodd"/></svg>;
